import Button from "@mui/material/Button";

import { useI18n } from "@/i18n/I18nProvider";
import { useLanguageSwitcher } from "@/hooks/useLanguageSwitcher";

/*
 * The label is the *other* language ("عربي" in the English dictionary and vice
 * versa), so the button always reads as the action it performs.
 */
export default function LanguageToggle({ sx }) {
  const { t } = useI18n();
  const { toggleLanguage } = useLanguageSwitcher();

  return (
    <Button aria-label="Change language" onClick={toggleLanguage} sx={sx}>
      {t.main_nav.lang}
    </Button>
  );
}
